module.exports = __webpack_public_path__ + "img/TG.241c8db1.svg";